import { render, staticRenderFns } from "./changeStudent.vue?vue&type=template&id=4d25b7fd&"
import script from "./changeStudent.vue?vue&type=script&lang=ts&"
export * from "./changeStudent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports